/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Pale_Emu_ActInputs */

const en_pale_pale_emu_act = /** @type {(inputs: Pale_Pale_Emu_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result Strategy`)
};

const de_pale_pale_emu_act = /** @type {(inputs: Pale_Pale_Emu_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis-Strategie`)
};

/**
* | output |
* | --- |
* | "Result Strategy" |
*
* @param {Pale_Pale_Emu_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_pale_emu_act = /** @type {((inputs?: Pale_Pale_Emu_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Pale_Emu_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_pale_emu_act(inputs)
	return de_pale_pale_emu_act(inputs)
});